import { jsx as e } from "react/jsx-runtime";
import { hiddenStripePaymentElementTermsOptions as i } from "../constants/stripe-payment-element-options.mjs";
import { useStripe as r, PaymentElement as t } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
function p() {
  return r() ? /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
    t,
    {
      options: {
        ...i,
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
export {
  p as StripeKlarnaDetails
};
